module.exports = __webpack_public_path__ + "static/img/qtcj03.9165d50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/qtcj03.png
// module id = 463
// module chunks = 0